import { render, staticRenderFns } from "./vFormAlert.vue?vue&type=template&id=39c76c37&scoped=true&"
import script from "./vFormAlert.vue?vue&type=script&lang=js&"
export * from "./vFormAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c76c37",
  null
  
)

export default component.exports